import { useCallback, useState } from "react";

import {
  useBankProvider,
  useCardProvider,
  useMerchantToken,
} from "Payments/globalPaymentsStateHooks";

import useImportScript from "Utilities/useImportScript";

import { getErrorMessageType } from "./staxTokenizationErrors";

export default function useStaxAPI() {
  const { providerIsStax: cardProviderIsStax } = useCardProvider();
  const { providerIsStax: bankProviderIsStax } = useBankProvider();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const merchantToken = useMerchantToken();

  const url =
    cardProviderIsStax || bankProviderIsStax
      ? "https://staxjs.staxpayments.com/stax.js"
      : null;
  const staxIsLoaded = useImportScript(url);

  const initializeStaxACHForm = useCallback(() => {
    // if (staxIsLoaded) return;

    if (!window.StaxJs) {
      alert(
        "Hmmm... something went wrong.  Please refresh the page and try again.  If it happens again, please email help@flocknote.com.  Error:wp_config"
      );
    }
    window.staxjs = new window.StaxJs(merchantToken, {});
  }, [merchantToken]);

  const initializeStaxForm = useCallback(() => {
    // if (staxIsLoaded) return;

    const cardNumber = document.querySelector("#card-number");
    const cardCVV = document.querySelector("#card-cvv");

    if (!cardNumber || !cardCVV) {
      setTimeout(() => {
        initializeStaxForm();
      }, 250);
    }

    if (!window.StaxJs) {
      alert(
        "Hmmm... something went wrong.  Please refresh the page and try again.  If it happens again, please email help@flocknote.com.  Error:wp_config"
      );
    }

    // The content of the CVC iframe gets placed differently by the different browers.
    // These are used to push it around to look the same on all browsers.
    const isChrome = Boolean(window.chrome);
    const isSafari = window.navigator.userAgent.indexOf("Safari") > -1;

    window.staxjs = new window.StaxJs(merchantToken, {
      number: {
        id: "card-number",
        style:
          "font-family: Montserrat, monospace; outline: none; border: none; padding: 0; display: block; z-index: 500; background: none; color: #fff; width: 100%; font-size: 26px; height: 32px; font-variant-numeric: tabular-nums; text-shadow: rgba(0, 0, 0, 0.5) 1px 1px 2px;",
        format: "prettyFormat",
        type: "text",
      },
      cvv: {
        id: "card-cvv",
        placeholder: "123",
        style: `font-family: Montserrat, monospace; color: white; font-size: 18px; height: 24px; margin-top: 1px; max-width: 50px; text-align: right; padding-inline: ${
          isChrome ? "0;" : isSafari ? "4px" : "0;"
        } font-variant-numeric: tabular-nums; text-shadow: rgba(0, 0, 0, 0.5) 1px 1px 2px;`,
      },
    });

    window.staxjs.showCardForm().then((handler) => {
      // console.log("form loaded");
      window.Spreedly.setStyle(
        "placeholder",
        "color: rgba(255, 255, 255, 0.4); text-shadow: none;"
      );
      // handler.setTestPan("4111111111111111");
      // handler.setTestCvv("123");
    });
  }, [merchantToken]);

  /**
   * @param {method} "bank" | "card"
   * @param {extraDetails} Object
   */
  const tokenize = ({ extraDetails, onSuccess, onFailure }) => {
    if (loading) return;
    setLoading(true);
    setError(false);

    window.staxjs
      .tokenize(extraDetails)
      .then((res) => {
        // console.log("tokenized", res);
        // TODO: save whatever we need to our db
        if (onSuccess) onSuccess(res);
      })
      .catch((err) => {
        setError("Hmm. Something went wrong saving your payment method.");
        console.log("err", err);
        const errorMessageType = getErrorMessageType(err);
        // onFailure requires an array of error types from CreditCardEntry/errorMessages.js
        if (onFailure) onFailure([errorMessageType]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    initializeStaxForm,
    initializeStaxACHForm,
    staxIsLoaded,
    tokenize,
    loading,
    error,
    loadStaxJs: () => staxIsLoaded,
  };
}
